/** This is a placeholder, not real render in dom */
var TreeNode = function TreeNode() {
  return null;
};

export default TreeNode;